/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "446")




export interface API56314Req {
  
  /** 任务id */
  taskId?: number;
  /** 任务进度：默认0,process传入10000，表示进度100%；传入9999，表示进度99.99% */
  process?: number;
};



export interface API56314Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /** data  */
  data?: boolean;
  /**   */
  exceptionMsg?: string;
  
};


// 56314 更新任务进度

export interface IUsePostAPI56314Return {
  /** 更新任务进度: 接口请求状态 */
  isAPI56314Loading: boolean;
  /** 更新任务进度: 接口请求返回数据 */
  dataAPI56314: API56314Res;
  /**  更新任务进度: 接口数据请求方法 */
  fetchAPI56314Data:  (inputs: API56314Req, config?: YWRequestConfig) => Promise<API56314Res>;
  /** 更新任务进度: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI56314 = ():IUsePostAPI56314Return => {
  let isMount = true;
  const [isAPI56314Loading, setIsAPI56314Loading] = useState(false);
  const [dataAPI56314, setDataAPI56314] = useState<API56314Res>({} as API56314Res);
  const requestUrl = `${basePath}/team-work/workTask/updateTaskProcess`;

  const fetchAPI56314Data = async (inputs: API56314Req, config?: YWRequestConfig): Promise<API56314Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API56314Req>) || {}) as API56314Req;
    
  
    if ( isMount ) {
      setIsAPI56314Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API56314Res>(`${basePath}/team-work/workTask/updateTaskProcess`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI56314(res || {} as API56314Res);
        setIsAPI56314Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI56314Loading(false);
      }
      return false as unknown as API56314Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI56314Loading,
    dataAPI56314,
    fetchAPI56314Data,
    requestUrl,
  }
}

